import { ApiResponse, isSessionError } from '@/common/request/types';
import { useAuthStore } from '@/modules/auth/store';
import router from '@/router/index';
import { useToast } from 'vue-toastification';

let sessionExpiredPromise: Promise<void> | null = null;

export const handleRequestError = async (error: ApiResponse): Promise<void> => {
    if (isSessionError(error.code)) {
        await handleSessionExpired(error);
        return;
    }

    useToast().error(error.data || 'Something wrong');
};

const handleSessionExpired = (error: ApiResponse): Promise<void> => {
    if (sessionExpiredPromise) {
        return sessionExpiredPromise;
    }

    sessionExpiredPromise = (async () => {
        const authStore = useAuthStore();
        if (!authStore.isAuthenticated) {
            return;
        }

        useToast().error(error.data || 'Something wrong');
        authStore.logout();
        router.replace('/login');
    })().finally(() => {
        sessionExpiredPromise = null;
    });

    return sessionExpiredPromise;
};
